/**
 * Local wallet — real balances, not painted ones.
 *
 * The library's top bar shows these numbers at the client's direction
 * (2026-08-09). The line this must never cross: the numbers have to be REAL —
 * persisted, loadable, and spendable the day the economy switches on. What
 * stays out until then is everything that *sells*: prices, purchase buttons,
 * a shop. A store reviewer treats non-functional commerce UI as
 * misrepresentation; a balance readout of a working wallet is not that.
 */
export interface Wallet {
  tickets: number;
  coins: number;
}

const KEY = 'hon.wallet';

/** First-run grant. Matches the design mock so the shipped screen and the
    reference read the same. */
const GRANT: Wallet = { tickets: 3, coins: 328 };

export function loadWallet(): Wallet {
  try {
    const raw: unknown = JSON.parse(localStorage.getItem(KEY) ?? 'null');
    if (
      typeof raw === 'object' && raw !== null &&
      typeof (raw as Wallet).tickets === 'number' && Number.isFinite((raw as Wallet).tickets) &&
      typeof (raw as Wallet).coins === 'number' && Number.isFinite((raw as Wallet).coins)
    ) {
      return { tickets: (raw as Wallet).tickets, coins: (raw as Wallet).coins };
    }
  } catch {
    /* fall through to the grant */
  }
  saveWallet(GRANT);
  return { ...GRANT };
}

export function saveWallet(w: Wallet): void {
  localStorage.setItem(KEY, JSON.stringify(w));
}
